import { useEffect, useState } from "react";
import useScriptHook from "react-script-hook";

export function useScriptLoader({ onLoad, ...args }) {
  const [loadingScript, errorScript] = useScriptHook(args);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!loadingScript && !errorScript && !loaded) {
      if (typeof onLoad === "function") onLoad();
      setLoaded(true);
    }
  }, [onLoad, loadingScript, errorScript, loaded]);

  return [(!loaded || loadingScript) && !errorScript, errorScript];
}

export default useScriptLoader;
